import { Countries, Translator } from '@merchant-portal/mp-models'
import {
  getCountryFromLanguage,
  getCurrencySymbol,
} from '../../models/countries'

const swedish = require('../../assets/translations/sv.json')
const danish = require('../../assets/translations/da.json')
const norwegian = require('../../assets/translations/nb.json')
const finnish = require('../../assets/translations/fi.json')

export const translator = new Translator(swedish, norwegian, danish, finnish)

const getLocale = () => {
  const localeString = localStorage.getItem('locale')
  return (localeString && JSON.parse(localeString)) || {}
}

const getTranslation = (label, args) => {
  const { language } = getLocale()
  if (language && language !== translator.currentLanguage) {
    translator.setLanguage(language)
  }
  const result = translator.getText(label)
  return result ? replaceArgs(result, args) : ''
}

export const getText = (label, arg, ...args) => {
  if (
    arg != null &&
    Object.prototype.toString.call(arg) === '[object Object]'
  ) {
    return getTranslation(label, arg)
  }
  return getTranslation(label, arg != null ? [arg, ...args] : [])
}

export const getCountry = () => {
  const { country } = getLocale()
  return country || Countries.SE
}

const templateFunctions = {
  currency: (language, value) => {
    const countryCode = getCountry()
    return (
      (value && getCurrencySymbol(countryCode).wrap(`{${value}}`)) ||
      getCurrencySymbol(countryCode).toString()
    )
  },
}

const getTemplateFunction = name =>
  templateFunctions[name] ||
  // eslint-disable-next-line no-console
  (!console.log('template function not found:', name) &&
    (value => `{${value}}`))

const replaceArgs = (text, args) => {
  let res = text
  const templateFunctionRegex = /{#(\w+)\((.*?)\)}/g
  let rex
  while ((rex = templateFunctionRegex.exec(text))) {
    const [match, func, argument] = rex
    res = res.replace(
      match,
      getTemplateFunction(func)(
        getCountryFromLanguage(translator.currentLanguage),
        ...argument.split(',').map(v => v.trim()),
      ),
    )
  }

  const templateWithoutFunctions = res
  const templateValueRegex = /{(.*?)}/g

  let valueRex
  while ((valueRex = templateValueRegex.exec(templateWithoutFunctions))) {
    const [match, key] = valueRex
    res = res.replace(match, args[key] || '')
  }
  return res
}
